import { isWindowEnv } from 'utils/env.utils'

export const desktopResolution = isWindowEnv() && window.innerWidth > 991
export const mobileResolution = isWindowEnv() && window.innerWidth <= 576

export const isDesktopResolution = () => window.innerWidth > 991
export const isMobileResolution = () => window.innerWidth <= 576
